import { api } from '@/shared/api/client';
import type { RequestPasswordResetPayload } from '../model/dto';

export const postAuthRequestPasswordReset = async (
  payload: RequestPasswordResetPayload
) => {
  const { data } = await api.post('/auth/request-password-reset/', payload);
  return data;
};
